import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getShortDepartment } from '@/api/requests/filters/shorts/getShortDepartment';

interface AppTableStore {
  appTableClearFunc: () => void;
}

interface MmFilterInterface {
  id: string;
  name: string;
}

export const useAppTableStore = defineStore('appTable', () => {
  let appTableClearFunc: () => void = () => {};
  let selectedItemFromInputYesNo = ref()

  const deleteAll = ref<boolean>(false)
  const currentPageNumber = ref<number>(1)

  const changeCurrentPageNumber = (num: number) => {
    currentPageNumber.value = num
  }
  const idForContractorMapping = ref<number | undefined>(undefined)
  const messageForContractorFilter = ref<string | undefined>(undefined)

  /// состоянии,которое зависит от выбранных чекбоксов,если не выбрано ни одного или больше 1 ,то кнопка copy отключается
  const stateForCopyButton = ref(false)

  const dataForEGKmMFilter = ref()  
  /// title для TableSlotHeaderComponent в случае редиректа со стороннего сайта
  const titleForHeaderSlot = ref()

  /// флаг для бонусов и отгрузок
  const bonusesFlag = ref(false)

  const scrollOffsetLeft = ref(0);
  const clientWidth = ref(0);
  const stateForCrudDialogue = ref()
  /////// значения для передачи в sendRequestFormData из autocomplete 
  const autoCompleteNewField = ref()
  /// title для TableSlotHeaderComponent в случае редиректа со стороннего сайта
  //test
  const testNodes = ref()
  const nodeKey = ref()
  const firstParentKey = ref()
  const allExpanded = ref()
  const categoriesSearchQuery = ref<string>('')

  function codeSerializer(){
    if(dataForEGKmMFilter.value){
      if(dataForEGKmMFilter.value[0]){
        const data  = dataForEGKmMFilter.value[0].code.split("-")[1]
        return data
        /* return String(data).replace(/^0+/, ''); */
      }
      
    }
    
  }

  const innMmFilter = ref<MmFilterInterface | null>(null)
  if (innMmFilter.value) {
    innMmFilter.value.id = innMmFilter.value?.name
    innMmFilter.value.name = innMmFilter.value?.id
  }

  async function getDepartmentsForContractorMapping() {
    if (idForContractorMapping.value) {
      return await getShortDepartment({ params: { query: { pageSize: 20, pageNumber: 1, IsActive: true, ExcludeContractorIds: [Number(idForContractorMapping.value)], filter: messageForContractorFilter.value, contractorIds: Number(idForContractorMapping.value) } } })
    }
    else {
      return await getShortDepartment({ params: { query: { pageSize: 20, pageNumber: 1, filter: messageForContractorFilter.value } } })
    }
  }

  return {
    innMmFilter,
    categoriesSearchQuery,
    appTableClearFunc,
    dataForEGKmMFilter,
    codeSerializer,
    selectedItemFromInputYesNo,
    clientWidth,
    scrollOffsetLeft,
    stateForCrudDialogue,
    stateForCopyButton,
    testNodes,
    nodeKey,
    firstParentKey,
    allExpanded,
    autoCompleteNewField,
    titleForHeaderSlot,
    deleteAll,
    currentPageNumber,
    changeCurrentPageNumber,
    idForContractorMapping,
    getDepartmentsForContractorMapping,
    messageForContractorFilter,
    bonusesFlag
  }
})

